import { ConfirmDialog } from "@/components/ui/ConfirmDialog";
import { formatCurrency } from "../utils/inviteeFormatters";

interface RentConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  amount: string;
}

export function RentConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  amount,
}: RentConfirmationModalProps) {
  const formattedAmount = formatCurrency(amount);

  return (
    <ConfirmDialog
      isOpen={isOpen}
      title="Rent Amount"
      message={`Please confirm the rent amount as ${formattedAmount || amount}`}
      primaryLabel="Ok"
      secondaryLabel=""
      primaryFirst
      presentation="saveChanges"
      overlayDataTestId="invitee-rent-confirmation-modal"
      primaryButtonDataTestId="invitee-rent-confirmation-modal-ok-button"
      closeButtonDataTestId="invitee-rent-confirmation-modal-close-button"
      onPrimary={onConfirm}
      onSecondary={onClose}
      onDismiss={onClose}
    />
  );
}
